import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putTaskDueDate = async ({ taskId, date }: JsonDataItem) => {
  const data = await baseQuery('task/updateduedate', {
    type: 'PUT',
    body: {
      task_ID: taskId,
      due_date: date, // 2024-03-22 15:31:00
    },
  });

  return data;
};
